function subscribeProductStockToKlaviyo(formElement) {

    const co = formElement.querySelector('input[name="a"]').value;
    const email = formElement.querySelector('input[name="email"]').value;
    const variant = formElement.querySelector('input[name="variant"]').value;

    const options = {
        method: 'POST',
        headers: {
            accept: 'application/json',
            revision: '2024-07-15',
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: email || "",
                            }
                        },
                    },
                    channels: ["EMAIL"]
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variant}`
                        }
                    }
                }
            }
        })
    };

    let result;

    return fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${co}`, options)
        .then(response => {
            result = response;
            return result;
        })
        .catch(err => console.error(err));
}

window.subscribeProductStockToKlaviyo = subscribeProductStockToKlaviyo;